import Vue from 'vue'
import VueRouter from 'vue-router'
import HomePage from '../views/HomePage.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'HomePage',
    component: HomePage
  },
  {
    path: '/login',
    name: 'LoginPage',
    component: () => import('../views/LoginPage.vue')
  },
  {
    path: '/register',
    name: 'RegisterPage',
    component: () => import('../views/RegisterPage.vue')
  },
  {
    path: '/favorites',
    name: 'FavoritesPage',
    component: () => import('../views/FavoritesPage.vue')
  },
  {
    path: '/products/:id',
    name: 'DetailPage',
    component: () => import('../views/DetailPage.vue')
  },
  {
    path: '*',
    name: 'NotFound',
    component: () => import('../views/NotFound.vue')
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  let authPages = ['/register','/login']
  let destIsAuth = authPages.includes(to.path)

  if (to.path == "/favorites" && !localStorage.access_token)
    next({ path: '/login' });
  else next();

  if ( destIsAuth && localStorage.access_token) next({ path: '/' });
  else next();
});

export default router
